export const GeneralErrors = {
    SUCCESS: 200,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    MISSINGFIELD: 406,
    PRECONDITIONAL_FAILED: 412,
    NOT_MATCH: 499,
    INTERNAL_SERVER_ERROR: 500,
    NO_CONNECTION: 'undefined',
    email_is_black_listed: 413,
    wrong_email_syntax: 414,
    host_does_not_exist: 415,
    invalid_mx_record: 416,
    the_contract_can_be_registered_only_the_warranty_start_date: 417,
    the_contract_can_be_registered_until: 418,
    you_are_not_authorised_to_register_a_contract_with_a_warranty_selling_date_more_then: 419,
};
